import { createContext } from 'react'
export const ApiContext = createContext([])
export const DashboardContext = createContext([])
export const BusinessEntitiesSourceContext = createContext([])
export const BusinessEntitiesTargetContext = createContext([])